import React, { useMemo } from "react";
import CompanyList from "./CompanyList";

export default function MostActiveSector({ rows, isLatest, monthLabel }) {
  const top = useMemo(() => {
    const sectors = {};
    rows.forEach(r => {
      if (!r.sector) return;
      if (!sectors[r.sector]) {
        sectors[r.sector] = {
          companies: new Set(),
          investingCompanies: new Set(),
          investingRows: [],
        };
      }
      sectors[r.sector].companies.add(r.company);
      if ((r.monthly_status || "").toLowerCase() === "investing") {
        sectors[r.sector].investingCompanies.add(r.company);
        sectors[r.sector].investingRows.push(r);
      }
    });
    let best = null;
    Object.entries(sectors).forEach(([sector, info]) => {
      if (!best || info.investingCompanies.size > best.investingCompanies.size) {
        best = { sector, ...info };
      }
    });
    return best;
  }, [rows]);

  if (!top) return null;

  const investCount = top.investingCompanies.size;
  const companies = Array.from(top.investingCompanies).sort();
  const total = top.companies.size;
  let summary = "";
  const investedTime = isLatest ? "in the last 30 days" : `in ${monthLabel}`;
  if (investCount === 0) {
    summary = `Out of ${total} ${top.sector} companies, none invested ${investedTime}.`;
  } else if (investCount === 1) {
    summary = `Out of ${total} ${top.sector} companies, ${companies[0]} ${isLatest ? "has " : ""}invested ${investedTime}.`;
  } else if (investCount === 2) {
    const verb = isLatest ? "have " : "";
    summary = `Out of ${total} ${top.sector} companies, ${companies[0]} and ${companies[1]} ${verb}invested ${investedTime}.`;
  } else if (investCount > 2) {
    const others = investCount - 2;
    const verb = isLatest ? "have " : "";
    summary = `Out of ${total} ${top.sector} companies, ${companies[0]}, ${companies[1]}, and ${others} other${others === 1 ? "" : "s"} ${verb}invested ${investedTime}.`;
  }

  const uniqueRows = Array.from(
    new Map(top.investingRows.map(r => [r.company, r])).values()
  );

  return (
    <div className="most-active-sector">
      <h2>Top sector investing in the U.S.</h2>
      <h3>{top.sector}</h3>
      {summary && <p>{summary}</p>}
      <CompanyList rows={uniqueRows} />
    </div>
  );
}
